import React, { useEffect } from 'react';
import { useFormik } from 'formik';

import * as Styles from './_apiKeySettings.module.scss';
import { useAppSelector } from '~redux/hooks';
import Yup from '~yup';
import LabelledInput from '~components/atoms/LabelledInput';
import ActionButton from '~components/atoms/ActionButton';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import combinedActions from '~redux/combinedActions';
import APIKeyHistoryTable from './APIKeyHistoryTable';
import { PermissionsEnum } from '~utils/enums';
import APIKeyHistoryTablePagination from './APIKeyHistoryTablePagination';
import ConfirmUpdateAPIKeyModal from './ConfirmRegenerateAPIKeyModal';
const SilverAPIKeySettings = () => {
    const dispatch = useDispatch();

    const silverApiKeySettings = useAppSelector(state => state.setting.silverApiKeySettings);
    const userDetails = useAppSelector(state => state.auth.userDetails);

    const openRegenerateAPIKeyModal = () => dispatch(combinedActions.settingSetRegenerateSilverAPIKeyModalIsOpen(true));

    useEffect(() => {
        dispatch(combinedActions.settingGetSilverAPIKeyHistoryListingAttempt());
    }, []);

    const initialAPIKeySettings = {
        apiKey: silverApiKeySettings?.apiKey || '',
        endDate: dayjs(silverApiKeySettings?.expiryDate).format('DD/MM/YYYY hh:mm A') || '',
    };

    const apiKeySettingsValidationSchema = Yup.object().shape({
        apiKey: Yup.string().matchNoLeadingAndTrailingWhiteSpaces().matchZeroWhiteSpace().matchMaxTwoDecimalNumbers().required('Api Key is required'),
        endDate: Yup.string().matchNoLeadingAndTrailingWhiteSpaces().matchZeroWhiteSpace().matchMaxTwoDecimalNumbers().required('End Date is required'),
    });

    const formik = useFormik({
        initialValues: initialAPIKeySettings,
        enableReinitialize: true, // Required because we get initialValues asynchronously
        validationSchema: apiKeySettingsValidationSchema,
        onSubmit: (values) => {
        },
    });

    const handleRegenerateKeyClick = () => {
        openRegenerateAPIKeyModal();
    };

    return (
        <div className={Styles.container}>
            <ActionButton
                label={'Regenerate Key'}
                onClick={handleRegenerateKeyClick}
                className={`${Styles['edit-button']} ${userDetails.roleName === 'Super Admin' ? '' : Styles['hide-button']}`}
                disabled={userDetails.roleName !== 'Super Admin'}
            />

            <form
                onSubmit={formik.handleSubmit}
                className={Styles['form-container']}
            >
                <div className={Styles['form-subcontainer']}>
                    <div>API Key</div>

                    <LabelledInput
                        id='apiKey'
                        name='apiKey'
                        label=':'
                        value={formik.values.apiKey}
                        error={formik.touched.apiKey ? formik.errors.apiKey : undefined}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={true}
                        isRow
                    />

                    <div>Expiry Date</div>
                    <LabelledInput
                        id='endDate'
                        name='endDate'
                        label=':'
                        value={formik.values.endDate}
                        error={formik.touched.endDate ? formik.errors.endDate : undefined}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={true}
                        isRow
                    />
                </div>
            </form>

            <APIKeyHistoryTable />

            <APIKeyHistoryTablePagination />

            <ConfirmUpdateAPIKeyModal />
        </div>
    );
};

export default SilverAPIKeySettings;
